import React, { useState } from 'react';
import {
  Box,
  Button,
  VStack,
  Heading,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from '@chakra-ui/react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const TimerSetup = () => {
  const [timeInMinutes, setTimeInMinutes] = useState(1);  // Default to 1 minute
  const navigate = useNavigate();

  const handleStart = () => {
    if (timeInMinutes && timeInMinutes > 0) {
      const timeInSeconds = parseInt(timeInMinutes, 10) * 60; // Convert minutes to seconds
      Cookies.set('countdownTime', timeInSeconds); // Save in seconds
      navigate('/countdown'); // Redirect to homepage
    }
  };

  return (
    <Box
      height="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="black"               // ✅ Black background
    >
      <VStack spacing={6}>
        <Heading color="white" fontSize="3xl">
          Set Timer
        </Heading>

        {/* ✅ Digital Style Number Input */}
        <NumberInput
          value={timeInMinutes}
          onChange={(valueString) => setTimeInMinutes(valueString)}
          min={1}
          max={120}
          step={1}
          size="lg"
          width="200px"
        >
          <NumberInputField
            textAlign="center"
            fontSize="5xl"          // ✅ Big digital-style font
            fontFamily="'Orbitron', sans-serif"  // ✅ Digital font
            color="white"
            bg="gray.800"
            border="none"
            _focus={{ boxShadow: 'none' }}
          />
          <NumberInputStepper>
            <NumberIncrementStepper bg="gray.600" color="white" />
            <NumberDecrementStepper bg="gray.600" color="white" />
          </NumberInputStepper>
        </NumberInput>

        {/* ✅ Start Button */}
        <Button
          colorScheme="teal"
          size="lg"
          width="200px"
          onClick={handleStart}
          fontSize="xl"
          fontWeight="bold"
        >
          Start Countdown
        </Button>
      </VStack>
    </Box>
  );
};

export default TimerSetup;